<template>
  <div 
    v-loading="loading"
    element-loading-background="rgba(0,0,0,0.3)"
  >
    
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      arrowList: [
        {
          name: "道路管理",
          path: "/transfer/roadList",
        },
        {
          name: "道路详情",
          path: "/transfer/roadInfo",
        },
      ],
      loading:true
    };
  },
  computed: {
    
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    let roadId = this.$route.query.id
    let pageNo= this.$route.params.pageNo
    let type= this.$route.params.type
    if(type==0){
      this.$router.push({name:'RoadInfo',query:{id:roadId},params:{pageNo:pageNo}})
    }else{
      this.$router.push({name:'UnRoadInfo',query:{id:roadId},params:{pageNo:pageNo}})
    }
  },
  beforeDestroy() {
    this.$store.commit("setNowRoadId", "");
  },
  methods: {
    
  },
  watch:{
    
  },
  components: {},
};
</script>
